/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rewrite_In_A_Different_StyleInputs */

const en_rewrite_in_a_different_style = /** @type {(inputs: Rewrite_In_A_Different_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rewrite in a Different Style`)
};

const es_rewrite_in_a_different_style = /** @type {(inputs: Rewrite_In_A_Different_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reescribir en un Estilo Diferente`)
};

const fr_rewrite_in_a_different_style = /** @type {(inputs: Rewrite_In_A_Different_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réécrire dans un style différent`)
};

const de_rewrite_in_a_different_style = /** @type {(inputs: Rewrite_In_A_Different_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In einem anderen Stil umschreiben`)
};

const ja_rewrite_in_a_different_style = /** @type {(inputs: Rewrite_In_A_Different_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`別のスタイルで書き直す`)
};

const zh_rewrite_in_a_different_style = /** @type {(inputs: Rewrite_In_A_Different_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用不同的风格重写`)
};

const ar_rewrite_in_a_different_style = /** @type {(inputs: Rewrite_In_A_Different_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إعادة الكتابة بأسلوب مختلف`)
};

const id_rewrite_in_a_different_style = /** @type {(inputs: Rewrite_In_A_Different_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tulis Ulang dalam Gaya Berbeda`)
};

const it_rewrite_in_a_different_style = /** @type {(inputs: Rewrite_In_A_Different_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riscrivi in uno Stile Diverso`)
};

const ru_rewrite_in_a_different_style = /** @type {(inputs: Rewrite_In_A_Different_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переписать в Другом Стиле`)
};

const pt_rewrite_in_a_different_style = /** @type {(inputs: Rewrite_In_A_Different_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reescrever num Estilo Diferente`)
};

const ko_rewrite_in_a_different_style = /** @type {(inputs: Rewrite_In_A_Different_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다른 스타일로 다시 쓰기`)
};

/**
* | output |
* | --- |
* | "Rewrite in a Different Style" |
*
* @param {Rewrite_In_A_Different_StyleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rewrite_in_a_different_style = /** @type {((inputs?: Rewrite_In_A_Different_StyleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rewrite_In_A_Different_StyleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rewrite_in_a_different_style(inputs)
	if (locale === "es") return es_rewrite_in_a_different_style(inputs)
	if (locale === "fr") return fr_rewrite_in_a_different_style(inputs)
	if (locale === "de") return de_rewrite_in_a_different_style(inputs)
	if (locale === "ja") return ja_rewrite_in_a_different_style(inputs)
	if (locale === "zh") return zh_rewrite_in_a_different_style(inputs)
	if (locale === "ar") return ar_rewrite_in_a_different_style(inputs)
	if (locale === "id") return id_rewrite_in_a_different_style(inputs)
	if (locale === "it") return it_rewrite_in_a_different_style(inputs)
	if (locale === "ru") return ru_rewrite_in_a_different_style(inputs)
	if (locale === "pt") return pt_rewrite_in_a_different_style(inputs)
	return ko_rewrite_in_a_different_style(inputs)
});